export const STRONG_8K    = 0;
export const NXT          = 1;
export const MEGA_OTT     = 2;
export const TRILLO       = 3;
export const DUST         = 4;
export const APP_SERVICES = 5;

export const PLATFORM_NAMES = {
  [STRONG_8K]:    "Strong 8k",
  [NXT]:          "NXT",
  [MEGA_OTT]:     "MegaOTT",
  [TRILLO]:       "Trillo",
  [APP_SERVICES]: "App Services",
};
